// This DataTable is failing for some reason
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import Plot from 'react-plotly.js';
import DataTable from 'react-data-table-component';
import './App.css';


const LandDetail = () => {
    const { id } = useParams();  // Get mortgage ID from the URL
    const [land, setLand] = useState(null); // State for mortgage details
    const [loading, setLoading] = useState(true);    // State for loading status
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchLandData = async () => {
            try {
                const response = await axios.get(`/api/balance_sheet/assets/physical_assets/resi_properties/land/${id}/`);
                setLand(response.data);
            } catch (error) {
                console.error('Error fetching mortgage details:', error);
                setError('Failed to fetch mortgage details.');
            } finally {
                setLoading(false);
            }
        };

        fetchLandData();
    }, [id]);  // Fetch data only when the mortgage ID changes


    // // Prepare data for the Plotly chart based on filtered data
    // const xData = filteredSchedule.map(row => new Date(row.payment_date)); // Dates for the x-axis
    // const principalPayments = filteredSchedule.map(row => parseFloat(row.principal_payment_amount) || 0); // Y-values for principal payments
    // const interestPayments = filteredSchedule.map(row => parseFloat(row.interest_payment_amount) || 0); // Y-values for interest payments


    const columns = [
        { name: 'Legal Desc.', selector: row => row.legal_description, sortable: true },
        { name: 'Parcel No.', selector: row => row.parcel_number, sortable: true },
        { name: 'Lot No.', selector: row => row.lot_number, sortable: true },
        { name: 'Plat No.', selector: row => row.plat_number, sortable: true },
        { name: 'Area (Acres)', selector: row => `${row.area_in_acres.toFixed(2)}`, sortable: true },
        { name: 'Tax District', selector: row => row.tax_district, sortable: true },
    ];

    if (loading) return <div>Loading land details...</div>; // Show loading message
    if (!land) return <div>No land found!</div>; // Handle case where no data is found


return (
    <div>
        <h1>Land Details: Put Something Here</h1>

        {/*/!* Container for Plotly Chart *!/*/}
        {/*<div className="plot-container">*/}
        {/*    <Plot*/}
        {/*        data={[*/}
        {/*            {*/}
        {/*                x: xData,*/}
        {/*                y: principalPayments,*/}
        {/*                type: 'scatter',*/}
        {/*                mode: 'lines+markers',*/}
        {/*                name: 'Principal Payments',*/}
        {/*            },*/}
        {/*            {*/}
        {/*                x: xData,*/}
        {/*                y: interestPayments,*/}
        {/*                type: 'scatter',*/}
        {/*                mode: 'lines+markers',*/}
        {/*                name: 'Interest Payments',*/}
        {/*            },*/}
        {/*        ]}*/}
        {/*        layout={{*/}
        {/*            title: {*/}
        {/*                text: 'Amortization Schedule',*/}
        {/*                font: { weight: 'bold' }*/}
        {/*            },*/}
        {/*            xaxis: { title: 'Payment Date' },*/}
        {/*            yaxis: { title: 'Payment Amount' },*/}
        {/*        }}*/}
        {/*    />*/}
        {/*</div>*/}

        {/* Container for DataTable */}
        {/*<div className="data-table-container">*/}
        {/*    <DataTable*/}
        {/*        title="Land Details Table"*/}
        {/*        columns={columns}*/}
        {/*        data={filteredSchedule} // Render the amortization schedule, filtered based on the toggle*/}
        {/*        pagination*/}
        {/*        paginationPerPage={50}*/}
        {/*    />*/}
        {/*</div>*/}
    </div>
    );
};

export default LandDetail;